'use strict';

import React from 'react';

const FormCheckbox = ({ input, defaultChecked, callback }) => {
  const styleClasses = 'onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover onsched-primary-color-hover onsched-primary-border-color-active onsched-primary-border-color-focus';
  const [checked, setChecked] = React.useState(false);

  React.useEffect(() => { if (defaultChecked) setChecked(true) }, [defaultChecked]);

  const checkboxChange = () => {
    setChecked(!checked);
    if (callback) callback(!checked);
  }

  return (
    <>
    <label className={`${styleClasses} FormCheckbox FormRadio`}>
      <i style={{ display: checked ? 'none' : 'block' }} className="fa-regular fa-toggle-off onsched-border-color"></i>
      <i style={{ display: checked ? 'block' : 'none' }} className="fa-regular fa-toggle-on onsched-primary-color"></i>
      <input 
        className="FormInput noselect" 
        name={input.name} 
        required={input.required} 
        type={input.type} 
        onChange={checkboxChange}
        />
      {input.label}
    </label>
    {input.detail && <span className='form-checkbox-input-detail'>{input.detail}</span>}
  </>
  )
};

export default FormCheckbox;
